import { Transform, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsOptional, IsString } from 'class-validator';

export interface TranslationDto {
  key: string;
  value: string;
  namespace: string;
  locale: string;
  needsValidation?: boolean;
}

type TranslationJSONValue =
  | string
  | TranslationJSONObject
  | Array<TranslationJSONValue>;
export interface TranslationJSONObject {
  [key: string]: TranslationJSONValue;
}

export class FetchTranslationDto {
  @IsArray()
  @IsString({ each: true })
  @Type(() => String)
  @Transform(({ value }) => value.split(','))
  namespaces: string[];

  @IsArray()
  @IsString({ each: true })
  @Type(() => String)
  @Transform(({ value }) => value.split(','))
  languages: string[];
}

export class CreateTranslationDto implements Partial<TranslationDto> {
  @IsString()
  value: string;

  @IsString()
  namespace: string;

  @IsString()
  locale: string;

  @IsString()
  key: string;

  @IsOptional()
  @IsBoolean()
  needsValidation?: boolean;
}

export class UpdateTranslationDto implements Partial<TranslationDto> {
  @IsString()
  value: string;

  @IsOptional()
  @IsBoolean()
  needsValidation?: boolean;
}
